<div class="selectDropdown" [ngStyle]="{ width: isMobile ? 'unset' : dropdownWidth }">
  <pp-hide-dropdown (ppHideDropdown)="hideDropdown()"></pp-hide-dropdown>

  @if (!noSearchBar) {
    <pp-search-box
      [ppPlaceholder]="'filter_items' | ppTranslate"
      (ppAction)="setKeyword($event)"
      [ppFocusOnInit]="true"
      ppSize="wide"
      class="dropdown__searchBar"
    ></pp-search-box>
  }

  <ul class="dropdownWrapper">
    @for (item of filteredItems; track item) {
      <li
        (click)="selectItem(item)"
        class="dropdownItem"
      [class.dropdownItem--selected]="
        selectedItem?.value === item.value &&
        selectedItem?.customFields === item?.customFields &&
        selectedItem?.tooltip === item?.tooltip
      "
        >
        @if (item.pngIcon) {
          <img
            ppImage
            class="select__icon icon-gap--right2x"
            [src]="item.pngIcon"
            />
        }
        @if (item.iconSrc) {
          <pp-icon
            [ppSrc]="item.iconSrc"
            ppClass="setSize14"
            ppTooltip
            [ppTitle]="item.tooltip"
            [ppSanitize]="false"
          ></pp-icon>
        }
        <span
          ppTooltip
          [ppTitle]="item.label"
          [ppTrimTooltip]="true"
          [ppOptions]="{ placement: 'right' }"
          class="select__label"
          >
          {{ item.label }}
        </span>
        @if (displaySubtext) {
          <span class="select__subtext">{{ item.subtext }}</span>
        }
      </li>
    }
  </ul>
</div>
